module.exports = __webpack_public_path__ + "static/media/SAM_1237.721dafe9.JPG";